const INITIAL_STATE = {
  data: {},
  errors: {},
}

const getNotification = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_NOTIFICATION_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_NOTIFICATION_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getNotification;